"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ModalModule = _interopRequireDefault(require("./Modal.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * "Modal" is a primitive for building higher level abstractions like "Dialog".
 */
var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: _this.props.defaultOpen || _this.props.open,
      showCloseAnimation: false,
      // to prevent false-click and close dialog. Useful for popup, that appears on non-user clicks (after timeout) or several fast clicks
      closeOnDimmed: !_this.props.preventCloseOnDimmedFromStart
    };

    _this.openModal = function () {
      _this.setState({
        open: true
      }, _this.props.onOpen);
    };

    _this.closeModal = function () {
      var isControlled = typeof _this.props.open !== 'undefined';

      if (isControlled) {
        _this.props.onClose();
      } else {
        if (_this.props.withAnimation) {
          _this.setState({
            showCloseAnimation: true
          });

          setTimeout(function () {
            return _this.setState({
              open: false,
              showCloseAnimation: false
            }, _this.props.onClose);
          }, 150);
        } else {
          _this.setState({
            open: false
          }, _this.props.onClose);
        }
      }
    };

    _this.onDimmedClose = function () {
      if (_this.state.closeOnDimmed) {
        _this.closeModal();
      }
    };

    _this.onKeyUp = function (_ref) {
      var code = _ref.code;

      if (code === 'Escape' && _this.state.open) {
        _this.closeModal();
      }
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keyup', this.onKeyUp);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2, prevState) {
      var _this2 = this;

      var prevOpen = _ref2.open;

      if (this.props.preventCloseOnDimmedFromStart && prevState.open !== this.state.open && this.state.open) {
        this.closeTimer = setTimeout(function () {
          return _this2.setState({
            closeOnDimmed: true
          });
        }, 1000);
      }

      var isControlled = typeof this.props.open !== 'undefined';

      if (isControlled && this.props.open !== prevOpen) {
        if (this.props.open) {
          this.setState({
            open: true
          });
        } else if (this.props.withAnimation) {
          if (!this.state.showCloseAnimation) {
            this.setState({
              showCloseAnimation: true
            });
            setTimeout(function () {
              return _this2.setState({
                open: false,
                showCloseAnimation: false
              });
            }, 150);
          }
        } else {
          this.setState({
            open: false
          });
        }
      }

      if (!this.state.open && this.props.preventCloseOnDimmedFromStart && this.state.closeOnDimmed) {
        this.setState({
          closeOnDimmed: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keyup', this.onKeyUp);
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          open = _this$state.open,
          showCloseAnimation = _this$state.showCloseAnimation;
      var _this$props = this.props,
          trigger = _this$props.trigger,
          children = _this$props.children,
          classes = _this$props.classes,
          El = _this$props.as,
          withAnimation = _this$props.withAnimation,
          passOpenStateAs = _this$props.passOpenStateAs,
          _this$props$modalProp = _this$props.modalProps,
          modalProps = _this$props$modalProp === void 0 ? {} : _this$props$modalProp;
      var render = typeof children === 'function' ? children(this.closeModal) : children;
      return _react.default.createElement(_react.default.Fragment, null, trigger && _react.default.cloneElement(trigger, _defineProperty({
        onClick: trigger.props.onClick || this.openModal
      }, passOpenStateAs, passOpenStateAs ? open : undefined)), open && _reactDom.default.createPortal(_react.default.createElement("div", {
        className: (0, _classnames.default)(_ModalModule.default.wrapper, classes.wrapper)
      }, _react.default.createElement(El, _extends({
        className: (0, _classnames.default)(_ModalModule.default.modal, withAnimation && _ModalModule.default.modal__withAnimation, withAnimation && showCloseAnimation && _ModalModule.default.hide, classes.modal)
      }, modalProps), render), _react.default.createElement("div", {
        className: (0, _classnames.default)(_ModalModule.default.dimmed, withAnimation && _ModalModule.default.dimmed__withAnimation, classes.bg),
        onClick: this.onDimmedClose
      })), document.body));
    }
  }]);

  return Modal;
}(_react.Component);

Modal.defaultProps = {
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  as: 'div',
  classes: {
    wrapper: '',
    modal: '',
    bg: ''
  },
  open: undefined,
  defaultOpen: false
};
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  trigger: _propTypes.default.node,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,

  /** Used for controlling modal from outside*/
  open: _propTypes.default.bool,
  defaultOpen: _propTypes.default.bool
} : void 0;
var _default = Modal;
exports.default = _default;